import templateUrl from 'webutils/address-input-prompt.htm'
import AddressInputPromptController from 'webutils/address-input-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const AddressInputPrompt = {
	open(options) {
		return modals.open(Object.assign({
			size: 'lg',
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: AddressInputPromptController,
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};

export default AddressInputPrompt;